import script from "./RecommendedReports.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecommendedReports.vue?vue&type=script&setup=true&lang=ts"

import "./RecommendedReports.vue?vue&type=style&index=0&id=1bf49260&lang=scss"

const __exports__ = script;

export default __exports__